import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { deleteBranch, resetBranchState } from '../store/branchActions';

BranchDeleteDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  branch: PropTypes.object,
};

export default function BranchDeleteDialog({ open, onClose, branch }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.branchReducer);

  const handleDelete = async () => {
    if (branch) {
      dispatch(deleteBranch(branch.id));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const handleClose = () => {
    dispatch(resetBranchState());
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Branch</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete "{branch?.name}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton color="secondary" variant="outlined" onClick={handleClose} disabled={isLoading}>
          Cancel
        </LoadingButton>
        <LoadingButton color="error" loading={isLoading} onClick={handleDelete} variant="contained">
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
